export type { WalletIndicatorTranslations } from "./wallet-indicator-pt-br";

export { WALLET_INDICATOR_PT_BR } from "./wallet-indicator-pt-br";
export { WALLET_INDICATOR_FR_FR } from "./wallet-indicator-fr-fr";
export { WALLET_INDICATOR_ES_MX } from "./wallet-indicator-es-mx";
export { WALLET_INDICATOR_EN_US } from "./wallet-indicator-en-us";
